import InputFormComponent from './InputFormComponent'
import TokenUpdate from './TokenUpdate'
import * as msgpub from "msgpub";
import React from 'react';
import {TextArea} from '../Common';
import { DisablesContext } from '../../constant/UserMqtt';
import { Box, Grid, ResponsiveContext } from 'grommet';
import { LoginLogStyle } from '../../constant/Styles';

const AREAS: {[key: string]: any[]} = {
    small: [
        { name: "area1", start: [0, 0], end: [0, 0] },
        { name: "area2", start: [0, 1], end: [0, 1] },
    ],
    medium: [
        { name: 'area1', start: [0, 0], end: [1, 0] },
        { name: 'area2', start: [1, 0], end: [2, 0] },
    ],
    large: [
        { name: 'area1', start: [0, 0], end: [1, 0] },
        { name: 'area2', start: [1, 0], end: [2, 0] },
    ]
};

const ROWS: {[key: string]: any[]} = {
    small: ['auto', 'auto'],
    medium: ['auto'],
    large: ['auto']
};

const COLUMNS: {[key: string]: any[]} = {
    small: ['auto'],
    medium: ['auto', 'auto'],
    large: ['auto', 'auto'],
}

export default function Settings(props: {user?: msgpub.User, setUser: any, setAus: any, setActiveIndice: any}){
    const {user, setUser, setAus, setActiveIndice} = props;
    const [token, setToken] = React.useState("");
    const [log, setLog] = React.useState("");
    const disables = React.useContext(DisablesContext);
    const size = React.useContext(ResponsiveContext); // Requires a Grommet Component.
    const areas = AREAS[size];
    const rows = ROWS[size];
    const columns = COLUMNS[size];

    return (
        <div style={{/*border: "5px solid #005bac",*/ padding: "5px", marginBottom: "0px"}}>
            <Grid
                rows={rows}
                columns={columns}
                gap="small"
                areas={areas}
            >
                <Box>
                    <InputFormComponent user={user} token={token} setToken={setToken} setLog={setLog} setUser={setUser} setAus={setAus} setActiveIndice={setActiveIndice}/>
                </Box>
                <Box>
                    <TokenUpdate user={user} setLog={setLog} setToken={setToken}/>
                </Box>
            </Grid>
            <Box style={{...LoginLogStyle}}>
                <TextArea texts={log} name={"connect log"} disabled={disables.userLog} id={"connection-log"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setLog(e.target.value)}}/>
            </Box>
        </div>
    );
}
